/**
 * @module actions/SamplePlayer
 */
import { SamplePlayerActions } from '../constants/Samples';

export function playSample(url, resumeTrackOnEnd) {
  return {
    type: SamplePlayerActions.PLAY,
    data: {
      url,
      resumeTrackOnEnd,
    },
  };
}

export function endSample() {
  return {
    type: SamplePlayerActions.STOPPED,
  };
}

export function shouldResumeTrack(resume) {
  return {
    type: SamplePlayerActions.SHOULD_RESUME_TRACK,
    data: {
      shouldResumeTrack: resume,
    },
  };
}

export function playSamples(samples) {
  return {
    type: SamplePlayerActions.PLAY_SAMPLES,
    data: {
      samples,
    },
  };
}

export function stopSamples() {
  return {
    type: SamplePlayerActions.STOP_SAMPLES,
  };
}
